import React from 'react';
import { Box, Typography, Paper, Stack } from '@mui/material';
import { VideoDisplay } from '../../common/components/VideoDisplay';
import { InfoIcon } from '../../common/components/InfoIcon';

const ComponentsShowcase: React.FC = () => {
  return (
    <Box 
      data-testid="components-showcase-container"
      sx={{ 
        bgcolor: '#f4f4f5', 
        minHeight: '100vh', 
        p: { xs: 2, sm: 3, md: 4 },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Paper 
        elevation={3}
        data-testid="components-showcase-paper"
        sx={{
          p: 4,
          maxWidth: '90vw',
          width: '100%',
          textAlign: 'center',
          borderRadius: 2
        }}
      >
        <Stack 
          direction="row" 
          spacing={1} 
          alignItems="center" 
          justifyContent="center" 
          sx={{ mb: 4 }}
          data-testid="components-showcase-header"
        >
          <Typography 
            variant="h5" 
            component="h1" 
            sx={{ 
              color: '#003140',
              fontWeight: 500
            }}
            data-testid="components-showcase-title"
          >
            Video Guide
          </Typography>
          <InfoIcon 
            resourceId="video-guide"
            iconSize="small"
            iconColor="primary"
            modalWidth={400}
            modalTitle="About the Video Guide"
            data-testid="components-showcase-info-icon"
          />
        </Stack>
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center',
            mb: 2,
            width: '100%',
            height: { xs: '300px', sm: '400px', md: '500px' }
          }}
          data-testid="components-showcase-video-container"
        >
          <VideoDisplay 
            videoUrl="https://stipepdevwesteu688.file.core.windows.net/ipcdevfestorage/Sample%20Video.mp4?sv=2023-11-03&st=2025-02-25T14%3A43%3A34Z&se=2025-03-21T14%3A58%3A34Z&sr=s&sp=r&sig=90jQEh8xYiQ%2FfVRwlWMRQOdqa73EnNYxWeawhDbq5K4%3D"
            thumbnailUrl="https://media.licdn.com/dms/image/v2/C4D0BAQHN66boduSa7w/company-logo_200_200/company-logo_200_200/0/1676636639587/cleverbit_software_logo?e=2147483647&v=beta&t=M5mumGsOdml5HdxJq1pBV4-1sxQ8EM5dAXuA_yaAZrc"
            tooltipTitle="Watch Tutorial"
            width="100%"
            height="100%"
          />
          <VideoDisplay 
            videoUrl="https://stipepdevwesteu688.file.core.windows.net/ipcdevfestorage/Sample%20Video.mp4?sv=2023-11-03&st=2025-02-25T14%3A43%3A34Z&se=2025-03-21T14%3A58%3A34Z&sr=s&sp=r&sig=90jQEh8xYiQ%2FfVRwlWMRQOdqa73EnNYxWeawhDbq5K4%3D"
            tooltipTitle="Watch Tutorial"
            width="100%"
            height="100%"
          />
        </Box>
        <Typography 
          variant="body2" 
          sx={{ 
            color: '#666',
            mt: 2
          }}
          data-testid="components-showcase-description"
        >
          Click the play button above to watch the tutorial video
        </Typography>
      </Paper>
    </Box>
  );
};

export default ComponentsShowcase;
